import React, { useState, useEffect } from 'react';
import './HomeSlider.css';

const HomeSlider = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const slides = [
    {
      id: 1,
      image: "https://i.postimg.cc/ry0D36vr/Adobe-Stock-89179068-1.jpg"
    },
    {
      id: 2,
      image: "https://i.postimg.cc/CK50Hwp2/home-slider-photo.png"
    },
    {
      id: 3,
      image: "https://i.postimg.cc/yNGHL2V8/home-slider-house.png"
    },
    {
      id: 4,
      image: "https://i.postimg.cc/m27tZYZZ/homepage-sliding-image-3-page-001-1535445924-37-39-61-226-2.jpg"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);

    return () => clearInterval(timer);
  }, []);

  const goToSlide = (index) => {
    setCurrentSlide(index);
  };

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % slides.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);
  };

  return (
    <div className="home-slider">
      <div className="slider-container">
        {slides.map((slide, index) => (
          <div
            key={slide.id}
            className={`slide ${index === currentSlide ? 'active' : ''}`}
            style={{ backgroundImage: `url(${slide.image})` }}
          />
        ))}
        
        <button className="slider-button prev" onClick={prevSlide}>
          &#10094;
        </button>
        <button className="slider-button next" onClick={nextSlide}>
          &#10095;
        </button>
      </div>
      
      <div className="slider-dots">
        {slides.map((_, index) => (
          <span
            key={index}
            className={`dot ${index === currentSlide ? 'active' : ''}`}
            onClick={() => goToSlide(index)}
          />
        ))}
      </div>
    </div>
  );
};

export default HomeSlider; 